/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import _ from 'underscore';

import { Analytics } from '@trello/atlassian-analytics';
import { renderComponent } from '@trello/component-wrapper';
import { forTemplate } from '@trello/i18n';
import { CardIdProvider } from '@trello/id-context';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import {
  getKey,
  Key,
  registerShortcutHandler,
  Scope,
  unregisterShortcutHandler,
} from '@trello/keybindings';
import { getScreenFromUrl } from '@trello/marketing-screens';
import { defaultRouter_DO_NOT_USE } from '@trello/router/legacy-router';

import { getCardUrl } from 'app/scripts/controller/urls';
import { CardCopyView } from 'app/scripts/views/card/CardCopyView';
import { toggleCardCoverChooserPopover } from 'app/scripts/views/card/CardCoverChooserPopover';
import { CardMemberSelectView } from 'app/scripts/views/card/CardMemberSelectView';
import { CardMoveView } from 'app/scripts/views/card/CardMoveView';
import { CardViewHelpers } from 'app/scripts/views/card/CardViewHelpers';
import { renderDueComplete } from 'app/scripts/views/card/CardViewPlugins';
import { trackSeparator } from 'app/scripts/views/card/SeparatorCard/SeparatorCard';
import { templates } from 'app/scripts/views/internal/templates';
import { View } from 'app/scripts/views/internal/View';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { StickerEditView } from 'app/scripts/views/stickers/StickerEditView';
import { QuickCardEditorTemplate } from 'app/scripts/views/templates/QuickCardEditorTemplate';
import { LazyCardDateRangePicker } from 'app/src/components/DateRangePicker/LazyCardDateRangePicker';
import { toggleLabelsPopover } from 'app/src/components/LabelsPopover';
import { ConvertCardRoleButton } from 'app/src/components/QuickCardEditor';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import {
  clearColorCover,
  clearCover,
  clearFullCover,
  getBadgesHtml,
  getFullCoverStylesForInitialRender,
  labelsData,
  renderBadges,
  renderCover,
  renderFullCover,
  renderLabels,
  renderMembers,
  renderPluginCover,
  toggleDueDateComplete,
  updateBadges,
  updateCheckItemsEarliestDue,
  updateDateBadges,
  updateDueDate,
} from './CardViewMixins';

const format = forTemplate('due_date_picker');

/**
 * The Edit Labels popover was rewritten under the assumption that it would only
 * be opened in the context of a board. We were totally unaware that this
 * view could be opened from within My Cards (only after sorting by due date),
 * and the experience would be completely broken there.
 *
 * This is an explicit allowlist for screens on which the Edit Labels button can
 * be rendered. Refactoring the labels popover to accommodate this use case is
 * not really viable considering the low usage of this view on other screens:
 * https://analytics.amplitude.com/atlassian/chart/gzncrgb
 */
const VALID_SCREENS_FOR_EDIT_LABELS = ['boardScreen', 'cardDetailScreen'];

class QuickCardEditorView extends View {
  static initClass() {
    // @ts-expect-error TS(2322): Type 'string' is not assignable to type '() => str... Remove this comment to see the full error message
    this.prototype.className = 'quick-card-editor';
    // @ts-expect-error
    this.prototype.isMouseDownOnOverlay = false;

    // @ts-expect-error
    this.prototype.renderDueComplete = renderDueComplete;

    this.prototype.events = {
      // @ts-expect-error TS(2322): Type '{ 'keydown .js-edit-card-title': string; 'cl... Remove this comment to see the full error message
      'keydown .js-edit-card-title': 'quickCardEditKeydown',
      'click .js-save-edits': 'saveEdits',

      'click .js-stop': 'stopCard',

      'click .js-edit-labels': 'editLabels',
      'click .js-edit-members': 'editMembers',
      'click .js-edit-cover': 'editCover',
      'click .js-move-card': 'moveCard',
      'click .js-copy-card': 'copyCard',
      'click .js-edit-due-date': 'editDueDate',
      'click .js-archive': 'archive',
      'click .js-due-date-badge': 'toggleDueDateComplete',

      click: 'checkCloseEditor',
      'click .js-close-editor': 'closeEditor',

      mousedown: 'mousedownOnOverlay',
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(options: any) {
    super(options);
    this.onShortcut = this.onShortcut.bind(this);
    registerShortcutHandler(this.onShortcut, { scope: Scope.Overlay });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static open(cardView: any) {
    this.close();

    const { $el } = cardView;
    const offset = $el.offset();

    const opts = {
      width: $el.width(),
      left: offset.left,
      top: offset.top,
      onMap: cardView.onMap,
      showEditLabels: VALID_SCREENS_FOR_EDIT_LABELS.includes(
        getScreenFromUrl(),
      ),
    };

    Analytics.sendScreenEvent({
      name: 'quickCardEditorInlineDialog',
      attributes: {
        view: getScreenFromUrl(),
      },
    });

    // @ts-expect-error TS(2339): Property 'current' does not exist on type 'typeof ... Remove this comment to see the full error message
    return (this.current = new QuickCardEditorView({
      model: cardView.model,
      onRemove: () => {
        // @ts-expect-error TS(2339): Property 'current' does not exist on type 'typeof ... Remove this comment to see the full error message
        this.current = null;
      },
    }).render(opts));
  }

  static close() {
    // @ts-expect-error TS(2339): Property 'current' does not exist on type 'typeof ... Remove this comment to see the full error message
    if (this.current != null) {
      // @ts-expect-error TS(2339): Property 'current' does not exist on type 'typeof ... Remove this comment to see the full error message
      this.current.closeEditor();
    }
    // @ts-expect-error TS(2339): Property 'current' does not exist on type 'typeof ... Remove this comment to see the full error message
    return (this.current = null);
  }

  initialize() {
    this.makeDebouncedMethods(
      'render',
      'renderStickers',
      'renderLabels',
      'renderCover',
      'renderBadges',
      'updateBadges',
      'rerender',
    );

    // We need to subscribe this onRouteChanged function to the router
    // so we would know when a user is navigating away from the page
    // where this was initialized. Otherwise the quick editor would
    // still be open regardless of the page the user navigates to.
    //
    // Specifically if they come to the board from the board list.
    // Without this subscription, after they hit the back button
    // the quick editor would sit on top of the board list page.
    // @ts-expect-error
    this.unsubscribeFromRouter = defaultRouter_DO_NOT_USE.subscribe(
      this.onRouteChanged.bind(this),
    );
    // @ts-expect-error
    this.routeWhenOpened = defaultRouter_DO_NOT_USE.getRoute().routePath;

    this.listenTo(this.model, {
      // @ts-expect-error
      'change:labels': this.renderLabelsDebounced,
      // @ts-expect-error
      'change:idLabels': this.renderLabelsDebounced,
      // @ts-expect-error
      'change:idAttachmentCover': this.renderCoverDebounced,
      // @ts-expect-error
      'change:cover': this.renderCoverDebounced,
      // @ts-expect-error
      'change:dueComplete': this.renderDueComplete,
      'change:due change:subscribed change:isTemplate':
        // @ts-expect-error
        this.renderBadgesDebounced,
      // @ts-expect-error
      'change:badges': this.updateBadgesDebounced,
      // @ts-expect-error
      'change:cardRole': this.rerenderDebounced,
    });

    this.listenTo(this.model.labelList, 'add remove reset change', () => {
      // @ts-expect-error
      return this.renderLabelsDebounced();
    });

    this.listenTo(
      this.model.memberList,
      'add remove reset',
      this.frameDebounce(this.renderMembers),
    );

    return this.listenTo(
      this.model.stickerList,
      'add remove reset change sort',
      function () {
        // @ts-expect-error
        return this.renderStickersDebounced();
      },
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onTracedUpdate(opts: any) {
    const { traceId, taskName, field } = opts;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (err: any, card: any) => {
      if (err) {
        throw Analytics.taskFailed({
          taskName,
          traceId,
          source: 'quickCardEditorInlineDialog',
          error: err,
        });
      } else {
        Analytics.sendUpdatedCardFieldEvent({
          field,
          source: 'quickCardEditorInlineDialog',
          containers: {
            card: { id: card.id },
            board: { id: card.idBoard },
            list: { id: card.idList },
            organization: { id: this.model?.getBoard()?.get('idOrganization') },
          },
          attributes: {
            taskId: traceId,
          },
        });
        Analytics.taskSucceeded({
          taskName,
          traceId,
          source: 'quickCardEditorInlineDialog',
        });
      }
    };
  }

  shouldRenderFullCover() {
    return false;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onRouteChanged(routeContext: any) {
    // Backbone will fire this function once when the editor is opened
    // this conditional is here just to prevent the editor from instantly closing.
    // @ts-expect-error
    if (routeContext.routePath !== this.routeWhenOpened) {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      return this.closeEditor();
    }
  }

  remove() {
    // @ts-expect-error
    this.unsubscribeFromRouter();
    unregisterShortcutHandler(this.onShortcut);
    // @ts-expect-error TS(2339): Property 'onRemove' does not exist on type '{}'.
    this.options.onRemove?.();
    return super.remove(...arguments);
  }

  showCover() {
    return this.model.getBoard().getPref('cardCovers') && this.model.hasCover();
  }

  showStickers() {
    return true;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onShortcut(event: any) {
    switch (getKey(event)) {
      case Key.Escape:
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        this.closeEditor();
        Analytics.sendPressedShortcutEvent({
          shortcutName: 'closeEditorShortcut',
          keyValue: Key.Escape,
          source: 'quickCardEditorInlineDialog',
          containers: {
            card: { id: this.model?.id },
            board: { id: this.model?.idBoard },
            list: { id: this.model?.idList },
            organization: { id: this.model?.getBoard()?.get('idOrganization') },
          },
        });
        return event.preventDefault();

      case Key.Enter:
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        this.saveEdits();
        Analytics.sendPressedShortcutEvent({
          shortcutName: 'saveEditsShortcut',
          keyValue: Key.Enter,
          source: 'quickCardEditorInlineDialog',
          containers: {
            card: { id: this.model?.id },
            board: { id: this.model?.idBoard },
            list: { id: this.model?.idList },
            organization: { id: this.model?.getBoard()?.get('idOrganization') },
          },
        });
        return event.preventDefault();

      default:
        break;
    }
  }

  // @ts-expect-error TS(2416): Property 'render' in type 'QuickCardEditorView' is... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  render(opts: any) {
    // @ts-expect-error
    this.opts = opts;

    const data = this.model.toJSON();
    data.labels = this.model.getLabels();
    data.showCover = this.showCover();
    data.hasStickers = this.model.hasStickers();
    data.cardUrl = getCardUrl(this.model);
    data.quickEdit = true;
    data.members = [];
    data.isTemplate = this.model.isOnBoardTemplate();
    data.isCardTemplate = !!this.model.get('isTemplate');
    data.cardRole = this.model.getCardRole();
    data.showEditLabels = opts.showEditLabels;

    // gotta position this thing
    // @ts-expect-error
    data.left = this.cLeft = opts.left;
    // @ts-expect-error
    data.top = this.cTop = opts.top;
    // @ts-expect-error
    data.width = this.cWidth = opts.width;
    // 160 is the width of the controls, which are absolutely positioned
    // @ts-expect-error
    const cRight = this.cWidth + this.cLeft + 160;
    const wWidth = $(window).width();

    // completely cover card on map
    if (opts.onMap) {
      data.top = data.top - 20;
    }

    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    if (cRight > wWidth) {
      data.leftButtons = true;
      // @ts-expect-error
      this._usingLeftButtons = true;
    }

    this.$el.html(templates.fill(QuickCardEditorTemplate, data, {}));

    this.renderStickers();
    this.renderCover();
    this.renderLabels();
    this.renderBadges();
    // @ts-expect-error
    this.renderMembers();
    this.checkShowCover();

    // @ts-expect-error
    this.renderDueComplete();

    // view.remove() removes the editor from# the DOM, which happens every time
    // we close the editor, so this is okay.
    $('#chrome-container').append(this.$el);

    this.calcHeight();

    this.focusInput();

    this.defer(() => {
      return $('.quick-card-editor-buttons', this.$el).addClass('fade-in');
    });

    // @ts-expect-error TS(2339): Property 'autosize' does not exist on type 'JQuery... Remove this comment to see the full error message
    $('.js-edit-card-title', this.$el).autosize();

    renderComponent(
      <CardIdProvider value={this.model.get('id')}>
        <ConvertCardRoleButton
          // eslint-disable-next-line react/jsx-no-bind
          onLoad={() => this.calcHeight()}
          analyticsContainers={this.model.getAnalyticsContainers()}
          isLegacyView={true}
        />
      </CardIdProvider>,
      this.el.querySelector('#convert-card-role-button-react-root'),
    );

    return this;
  }

  rerender() {
    // @ts-expect-error
    this.render(this.opts);
  }

  calcHeight() {
    let top;
    const wHeight = $(window).height();

    // Might overflow the window height so lets make sure that doesn't happen.
    // This needs to happen here because it's in the DOM now and the
    // calculations will be right.
    const cHeight = $('.quick-card-editor-card', this.$el).outerHeight();
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    if (this.cTop + cHeight > wHeight) {
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      top = wHeight - cHeight - 8;
      $('.quick-card-editor-card', this.$el).css({ top });
    }

    const $buttons = $('.quick-card-editor-buttons', this.$el);
    const bHeight = $buttons.outerHeight();
    const bOffset = $buttons.offset();

    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    if (bHeight + bOffset.top > wHeight) {
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      $buttons.css({ top: cHeight - bHeight });
    }
  }

  renderStickers() {
    const $stickers = $('.js-card-stickers', this.$el).empty();
    const subviews = Array.from(this.model.stickerList.models).map((sticker) =>
      this.subview(StickerEditView, sticker, { card: this.model }),
    );
    this.appendSubviews(subviews, $stickers);

    $('.list-card', this.$el).toggleClass(
      'is-stickered',
      this.model.hasStickers(),
    );

    return this;
  }

  checkShowCover() {
    $('.list-card', this.$el)
      .toggleClass('is-covered', this.showCover())
      .toggleClass('is-stickered', this.model.hasStickers());

    return this;
  }

  focusInput() {
    return $('.js-edit-card-title', this.$el).focus().select();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showPopOver(e: any, viewClass: any, opts: any) {
    if (opts == null) {
      opts = {};
    }
    stopPropagationAndPreventDefault(e);

    PopOver.toggle({
      elem: $(e.target).closest('a'),
      view: new viewClass({
        model: this.model,
        ...opts,
      }),
      // @ts-expect-error
      alignRight: this._usingLeftButtons,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showDateRangePicker(e: any) {
    const elem = $('.js-card-menu', this.$el);
    if (elem) {
      return PopOver.toggle({
        elem: $(e.target).closest('a'),
        getViewTitle: () => format('dates'),
        keepEdits: true,
        reactElement: (
          <LazyCardDateRangePicker
            due={this.model.get('due')}
            start={this.model.get('start')}
            dueReminder={this.model.get('dueReminder')}
            // eslint-disable-next-line react/jsx-no-bind
            hidePopover={() => PopOver.hide()}
            idCard={this.model.id}
            idBoard={this.model.getBoard()?.id}
            idOrg={this.model.getBoard()?.get('idOrganization')}
          />
        ),
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  editLabels(e: any) {
    toggleLabelsPopover({
      idCard: this.model.id,
      source: 'quickCardEditorInlineDialog',
      triggerElement: $(e.target).closest('a')[0],
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  editMembers(e: any) {
    return this.showPopOver(e, CardMemberSelectView, {
      source: 'quickCardEditorInlineDialog',
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  editCover(e: any) {
    toggleCardCoverChooserPopover({
      // @ts-expect-error TS(2740): Type 'JQuery<HTMLElement>' is missing the followin... Remove this comment to see the full error message
      elem: $(e.currentTarget, this.$el),
      cardId: this.model.id,
      traceSource: 'quickCardEditorInlineDialog',
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  copyCard(e: any) {
    return this.showPopOver(e, CardCopyView, {
      onCopy: this.closeEditor.bind(this),
      source: 'quickCardEditorInlineDialog',
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  editDueDate(e: any) {
    this.showDateRangePicker(e);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  moveCard(e: any) {
    const onCommit = this.closeEditor.bind(this);
    return this.showPopOver(e, CardMoveView, {
      onCommit,
      source: 'quickCardEditorInlineDialog',
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  archive(e: any) {
    stopPropagationAndPreventDefault(e);

    const traceId = Analytics.startTask({
      taskName: 'edit-card/closed',
      source: 'quickCardEditorInlineDialog',
    });

    this.model.close(
      traceId,
      this.onTracedUpdate({
        traceId,
        taskName: 'edit-card/closed',
        field: 'closed',
      }),
    );

    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    this.closeEditor();

    Analytics.sendTrackEvent({
      action: 'archived',
      actionSubject: 'card',
      source: 'quickCardEditorInlineDialog',
      containers: {
        card: { id: this.model?.id },
        board: { id: this.model?.idBoard },
        list: { id: this.model?.idList },
        organization: { id: this.model?.getBoard()?.get('idOrganization') },
      },
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  quickCardEditKeydown(e: any) {
    if (getKey(e) === Key.Enter) {
      return this.saveEdits(e);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  saveEdits(e: any) {
    stopPropagationAndPreventDefault(e);

    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    const val = $('.js-edit-card-title', this.$el).val().trim();
    const currentVal = this.model.get('name');

    if (val === currentVal) {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      this.closeEditor();
    } else if (val !== '') {
      const traceId = Analytics.startTask({
        taskName: 'edit-card/name',
        source: 'quickCardEditorInlineDialog',
      });
      this.model.recordAction({
        type: 'rename',
        name: val,
        previousName: currentVal,
      });
      this.model.update(
        { name: val, traceId: traceId },
        this.onTracedUpdate({
          traceId,
          taskName: 'edit-card/name',
          field: 'name',
        }),
      );
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      this.closeEditor();
      trackSeparator({
        cardName: val,
        idCard: this.model.id,
        attributes: {
          category: 'quick card editor',
          method: 'by editing name',
        },
      });
    } else {
      $('.js-edit-card-title', this.$el).focus().select();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mousedownOnOverlay(e: any) {
    // @ts-expect-error
    this.isMouseDownOnOverlay = e.target === this.$el[0];
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  checkCloseEditor(e: any) {
    // @ts-expect-error
    if (this.isMouseDownOnOverlay) {
      // @ts-expect-error
      this.isMouseDownOnOverlay = false;

      if (PopOver.isVisible) {
        PopOver.hide();
      } else if ($('.sticker.editing', this.$el).length > 0) {
        this.stopEditingStickers();
      } else {
        this.closeEditor(e);
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  closeEditor(e: any) {
    this.remove();
    PopOver.hide();
    Analytics.sendClosedComponentEvent({
      componentName: 'quickCardEditorInlineDialog',
      componentType: 'inlineDialog',
      containers: {
        card: { id: this.model?.id },
        board: { id: this.model?.idBoard },
        list: { id: this.model?.idList },
        organization: { id: this.model?.getBoard()?.get('idOrganization') },
      },
      source: getScreenFromUrl(),
    });
  }

  stopEditingStickers() {
    for (const sticker of Array.from(_.clone(this.model.stickerList.models))) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      sticker.trigger('stopEditing');
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  stopCard(e: any) {
    e?.stopPropagation();
    PopOver.hide();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openMemberOnCardMenu(e: any) {
    return CardViewHelpers.openMemberOnCardMenu.call(this, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openMemberOnAtMention(e: any) {
    return CardViewHelpers.openMemberOnAtMention.call(this, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getMemberOnCardHtml(member: any) {
    return CardViewHelpers.getMemberOnCardHtml.call(this, member);
  }

  clearCover() {
    return clearCover.call(this);
  }
  clearColorCover() {
    return clearColorCover.call(this);
  }
  renderCover() {
    return renderCover.call(this);
  }
  clearFullCover() {
    return clearFullCover.call(this);
  }
  renderFullCover() {
    return renderFullCover.call(this);
  }
  getFullCoverStylesForInitialRender() {
    return getFullCoverStylesForInitialRender.call(this);
  }
  renderPluginCover() {
    return renderPluginCover.call(this);
  }
  getBadgesHtml() {
    return getBadgesHtml.call(this);
  }
  renderBadges() {
    return renderBadges.call(this);
  }
  updateDateBadges() {
    return updateDateBadges.call(this);
  }
  updateDueDate() {
    return updateDueDate.call(this);
  }
  updateCheckItemsEarliestDue() {
    return updateCheckItemsEarliestDue.call(this);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  toggleDueDateComplete(e: any) {
    return toggleDueDateComplete.call(this, e);
  }
  updateBadges() {
    return updateBadges.call(this);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderMembers(e: any) {
    return renderMembers.call(this, e);
  }
  labelsData() {
    return labelsData.call(this);
  }
  renderLabels() {
    return renderLabels.call(this);
  }
}
QuickCardEditorView.initClass();

export { QuickCardEditorView };
